// extracted by mini-css-extract-plugin
export default {"fullWidth":"nha-z","hasStyledAspectRatio":"oha-z"};